(() => {
  if (window.CedarAmberFeatured) {
    window.CedarAmberFeatured.init();
    return;
  }
  const instances = new Map();

  function mount(root) {
    if (instances.has(root)) return;
    const life = new AbortController();
    const signal = life.signal;
    const $ = selector => root.querySelector(selector);
    const $$ = selector => [...root.querySelectorAll(selector)];
    const on = (target, event, handler, options = {}) => target?.addEventListener(event, handler, { ...options, signal });
    let strings = {};
    try { strings = JSON.parse($('[data-ca-pdp-strings]')?.textContent || '{}'); } catch {}
    const motion = $$('[data-ca-f-motion]');
    const viewer = $('[data-ca-f-viewer]');
    const viewport = $('[data-ca-f-viewport]');
    const viewerImage = $('[data-ca-f-viewer-image]');
    const viewerStatus = $('[data-ca-f-viewer-status]');
    let frame = 0;
    let opener;
    let oldOverflow = '';
    let imageRevision = 0;
    let pendingImage;
    const offerDialog = $('[data-ca-offer-dialog]');
    const offerBackdrop = $('[data-ca-offer-backdrop]');
    const offerHasResponse = !!$('[data-ca-offer-success], [data-ca-offer-errors]');
    const canOfferOverlay = typeof offerDialog?.show === 'function';
    const offerEnd = Date.parse(root.dataset.caOfferEnd || '');
    let offerOpener;
    let offerOverflow = '';
    let offerTimer;
    let timeRevision = 0;
    let timeRequest;
    let activeTime = 'day';
    if (canOfferOverlay) offerDialog.removeAttribute('open');

    function offerActive() { return Number.isFinite(offerEnd) && Date.now() < offerEnd; }

    function expireOffer() {
      clearTimeout(offerTimer);
      if (!Number.isFinite(offerEnd)) return;
      if (!offerActive()) {
        $$('[data-ca-offer-live]').forEach(element => { element.hidden = true; });
        if (offerDialog) {
          offerDialog.querySelector('form')?.setAttribute('hidden', '');
          const message = $('[data-ca-offer-expired]');
          if (message) message.hidden = false;
        }
      } else {
        offerTimer = setTimeout(expireOffer, Math.min(86400000, Math.max(1, offerEnd - Date.now())));
      }
    }

    function openOffer(trigger) {
      if (!canOfferOverlay || !offerActive()) return false;
      if (offerDialog.open) return true;
      offerOpener = trigger;
      offerOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      // Keep Shopify's body-level CAPTCHA challenge reachable above this ordinary overlay.
      // Native showModal() would place the form in the top layer and make that challenge inert.
      if (offerBackdrop) offerBackdrop.hidden = false;
      offerDialog.show();
      offerDialog.animate([{ opacity: .3, transform: 'translateY(18px) scale(.98)' }, { opacity: 1, transform: 'translateY(0) scale(1)' }], { duration: 350, easing: 'cubic-bezier(.23,1,.32,1)' });
      const focusTarget = $('[data-ca-offer-success], [data-ca-offer-errors]') || offerDialog.querySelector('input[type=email]');
      focusTarget?.focus({ preventScroll: true });
      return true;
    }

    function restoreOffer() {
      if (offerDialog?.open) return;
      if (offerBackdrop) offerBackdrop.hidden = true;
      document.documentElement.style.overflow = offerOverflow;
      if (offerOpener?.isConnected) offerOpener.focus({ preventScroll: true });
      else if (offerHasResponse) {
        const choice = $('.ca-f-purchase-card');
        choice?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    async function copyOffer() {
      const code = $('[data-ca-offer-success] [data-ca-offer-code]');
      const status = $('[data-ca-copy-status]');
      if (!code || !status || !offerActive()) return;
      try {
        await navigator.clipboard.writeText(code.textContent.trim());
        if (!signal.aborted) status.textContent = strings.copySuccess || 'Code copied.';
      } catch {
        if (signal.aborted) return;
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(code);
        selection?.removeAllRanges();
        selection?.addRange(range);
        status.textContent = strings.copyManual || 'Select and copy this code to use at checkout.';
      }
    }

    async function selectTime(value) {
      const next = $(`[data-ca-time-frame="${value}"]`);
      if (!next || !['day', 'evening'].includes(value)) return;
      const revision = ++timeRevision;
      timeRequest?.abort();
      timeRequest = new AbortController();
      const requestSignal = timeRequest.signal;
      const controls = $$('[data-ca-time-select]');
      const status = $('[data-ca-time-status]');
      const current = () => revision === timeRevision && !requestSignal.aborted && !signal.aborted && root.isConnected;
      controls.forEach(button => button.removeAttribute('aria-busy'));
      if (value === activeTime) {
        $$('[data-ca-time-frame]').forEach(frame => {
          frame.getAnimations().forEach(animation => animation.cancel());
          frame.hidden = frame !== next;
          frame.inert = frame !== next;
          frame.setAttribute('aria-hidden', String(frame !== next));
          frame.classList.toggle('is-active', frame === next);
        });
        if (status) status.textContent = '';
        return;
      }
      const image = next.querySelector('img');
      if (!image) return;
      const button = controls.find(control => control.dataset.caTimeSelect === value);
      button?.setAttribute('aria-busy', 'true');
      if (status) status.textContent = strings.loadingImage || 'Loading photograph…';
      image.loading = 'eager';
      image.fetchPriority = 'low';
      try {
        if (!image.complete) await new Promise((resolve, reject) => {
          let timeout;
          const cleanup = () => { clearTimeout(timeout); image.removeEventListener('load', loaded); image.removeEventListener('error', failed); requestSignal.removeEventListener('abort', failed); };
          const loaded = () => { cleanup(); resolve(); };
          const failed = () => { cleanup(); reject(new Error('Image unavailable')); };
          image.addEventListener('load', loaded, { once: true });
          image.addEventListener('error', failed, { once: true });
          requestSignal.addEventListener('abort', failed, { once: true });
          timeout = setTimeout(failed, 18000);
        });
        if (!image.naturalWidth || image.dataset.caFallbackUsed === 'true') throw new Error('Image unavailable');
        try { await image.decode(); } catch {}
        if (!current()) return;
        const previous = $(`[data-ca-time-frame="${activeTime}"]`);
        activeTime = value;
        $$('[data-ca-time-frame]').forEach(frame => {
          frame.getAnimations().forEach(animation => animation.cancel());
          frame.classList.toggle('is-active', frame === next);
          frame.inert = frame !== next;
          frame.setAttribute('aria-hidden', String(frame !== next));
          frame.hidden = frame !== next && frame !== previous;
        });
        next.hidden = false;
        next.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 650, easing: 'ease-in-out' }).finished.catch(() => {}).then(() => {
          if (current()) $$('[data-ca-time-frame]').forEach(frame => { frame.hidden = frame !== next; });
        });
        controls.forEach(control => control.setAttribute('aria-pressed', String(control.dataset.caTimeSelect === value)));
        const caption = $('[data-ca-time-caption]');
        if (caption) caption.textContent = strings[value === 'day' ? 'daylight' : 'evening'] || value;
        if (status) status.textContent = caption?.textContent || '';
      } catch {
        if (current() && status) status.textContent = strings.imageError || 'The next photograph could not load. The current view remains visible.';
      } finally {
        if (current()) controls.forEach(control => control.removeAttribute('aria-busy'));
      }
    }

    function useFallback(image) {
      if (image.dataset.caFallbackUsed === 'true') return;
      const fallback = image.dataset.caFFallback;
      if (!fallback) return;
      image.dataset.caFallbackUsed = 'true';
      const picture = image.closest('picture');
      picture?.querySelectorAll('source').forEach(source => source.remove());
      if (picture) picture.dataset.sourceState = 'fallback';
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = fallback;
      image.alt = root.dataset.productTitle || image.alt;
      const link = image.closest('[data-ca-f-zoom], [data-ca-zoom], [data-ca-thumbnail]');
      if (link) link.href = fallback;
    }

    $$('img[data-ca-f-fallback]').forEach(image => {
      on(image, 'error', () => useFallback(image));
      if (image.complete && image.naturalWidth === 0) useFallback(image);
    });

    function updateMotion() {
      frame = 0;
      if (!root.isConnected) return;
      const height = innerHeight;
      const mobileChoice = $('[data-ca-mobile-choose]');
      const buyButton = $('[data-ca-add]');
      if (mobileChoice && buyButton) {
        const nextHidden = !(innerWidth < 990 && buyButton.getBoundingClientRect().top > height - 65 && root.getBoundingClientRect().top < height);
        if (mobileChoice.hidden !== nextHidden) mobileChoice.hidden = nextHidden;
      }
      if (root.dataset.caMotionReady === 'true') return;
      for (const element of motion) {
        const rect = element.getBoundingClientRect();
        if (rect.bottom < -80 || rect.top > height + 80) continue;
        const progress = Math.max(0, Math.min(1, (height * .9 - rect.top) / Math.max(1, rect.height + height * .4)));
        const center = Math.max(-1, Math.min(1, (height / 2 - rect.top - rect.height / 2) / height));
        const distance = innerWidth < 750 ? 5 : Math.min(14, rect.height * .015);
        element.style.setProperty('--ca-f-progress', progress.toFixed(4));
        element.style.setProperty('--ca-f-drift', `${(center * distance).toFixed(2)}px`);
        element.style.setProperty('--ca-f-scale', (1.025 - Math.min(1, progress * 1.65) * .025).toFixed(4));
      }
    }

    function queueMotion() { if (!frame) frame = requestAnimationFrame(updateMotion); }

    function cancelImage() {
      imageRevision += 1;
      if (pendingImage) {
        pendingImage.onload = null;
        pendingImage.onerror = null;
        pendingImage.removeAttribute('src');
      }
      pendingImage = null;
    }

    function zoomImage(zoomed) {
      viewer?.classList.toggle('is-zoomed', zoomed);
      const button = $('[data-ca-f-viewer-zoom]');
      if (button) {
        button.setAttribute('aria-pressed', String(zoomed));
        button.textContent = zoomed ? strings.zoomOut || 'Zoom out' : strings.zoomIn || 'Zoom in';
      }
      viewport?.scrollTo(0, 0);
    }

    function openViewer(link) {
      if (!viewer || typeof viewer.showModal !== 'function') return false;
      cancelImage();
      const revision = imageRevision;
      const source = link.querySelector('img');
      const fullURL = link.href;
      const current = () => revision === imageRevision && !signal.aborted && root.isConnected;
      const hasPreview = source?.complete && source.naturalWidth > 0;
      zoomImage(false);
      viewerStatus.textContent = hasPreview ? '' : strings.loadingImage || 'Loading photograph…';
      viewerImage.alt = source?.alt || root.dataset.productTitle;
      if (hasPreview) {
        const previewURL = source.currentSrc || source.src;
        if (viewerImage.src !== fullURL || !viewerImage.naturalWidth) viewerImage.src = previewURL;
      }
      opener = link;
      oldOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      viewer.showModal();
      $('[data-ca-f-viewer-close]').focus({ preventScroll: true });
      if (viewerImage.complete && viewerImage.naturalWidth > 0 && viewerImage.src === fullURL) return true;
      const loading = new Image();
      loading.decoding = 'async';
      pendingImage = loading;
      loading.onload = async () => {
        try { await loading.decode(); } catch {}
        if (!current() || !loading.naturalWidth) return;
        viewerImage.src = fullURL;
        viewerStatus.textContent = '';
      };
      loading.onerror = () => {
        if (!current()) return;
        viewerStatus.textContent = strings.imageError || 'The larger photograph could not load.';
      };
      loading.src = fullURL;
      return true;
    }

    function primeThumbnail(thumb) {
      const index = thumb?.dataset.mediaIndex;
      if (index == null) return;
      const image = root.querySelector(`[data-ca-media][data-media-index="${index}"] img`);
      if (image) {
        image.loading = 'eager';
        image.fetchPriority = 'low';
      }
    }

    on(root, 'click', event => {
      const target = event.target.closest('a,button');
      if (!target || event.defaultPrevented) return;
      if (target.tagName === 'A' && (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0)) return;
      if (target.matches('[data-ca-offer-open], a[href="#fall-welcome"]')) {
        if (openOffer(target)) event.preventDefault();
        return;
      }
      if (target.matches('[data-ca-offer-close]')) { offerDialog?.close(); return; }
      if (target.matches('[data-ca-offer-copy]')) { copyOffer(); return; }
      if (target.matches('[data-ca-time-select]')) { selectTime(target.dataset.caTimeSelect); return; }
      if (target.matches('[data-ca-f-zoom]') && openViewer(target)) event.preventDefault();
      if (target.matches('[data-ca-f-viewer-close]')) viewer.close();
      if (target.matches('[data-ca-f-viewer-zoom]')) zoomImage(!viewer.classList.contains('is-zoomed'));
      if (target.matches('a[href^="#"]')) {
        const id = target.getAttribute('href').slice(1);
        const destination = document.getElementById(id);
        if (!destination || !root.contains(destination)) return;
        event.preventDefault();
        destination.scrollIntoView({ behavior: 'smooth', block: 'start' });
        const heading = destination.querySelector('h1,h2,summary');
        if (heading) { if (!heading.hasAttribute('tabindex') && heading.tagName !== 'SUMMARY') heading.tabIndex = -1; heading.focus({ preventScroll: true }); }
        history.replaceState(history.state, '', `#${id}`);
      }
    });
    on(root, 'pointerover', event => primeThumbnail(event.target.closest('[data-ca-thumbnail]')), { passive: true });
    on(root, 'focusin', event => primeThumbnail(event.target.closest('[data-ca-thumbnail]')));
    on(viewport, 'click', () => zoomImage(!viewer.classList.contains('is-zoomed')));
    on(viewer, 'close', () => {
      if (viewer.open) return;
      cancelImage();
      document.documentElement.style.overflow = oldOverflow;
      zoomImage(false);
      opener?.focus({ preventScroll: true });
    });
    on(window, 'scroll', queueMotion, { passive: true });
    on(window, 'resize', queueMotion, { passive: true });
    on(offerDialog, 'close', restoreOffer);
    on(offerBackdrop, 'click', () => offerDialog?.close());
    on(offerDialog, 'keydown', event => {
      if (event.defaultPrevented || event.ctrlKey || event.metaKey || event.altKey || !offerDialog.contains(document.activeElement)) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        offerDialog.close();
      }
      if (event.key === 'Tab') {
        const controls = [...offerDialog.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]):not([type=hidden]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]')].filter(element => element.getClientRects().length > 0);
        const first = controls[0];
        const last = controls.at(-1);
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }
    });
    on(document, 'visibilitychange', () => { if (!document.hidden) expireOffer(); });
    on(window, 'hashchange', () => { if (location.hash === '#fall-welcome') openOffer(); });
    on(document, 'click', event => {
      if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[href]');
      if (!link) return;
      const destination = new URL(link.href, location.origin);
      const productPath = new URL(root.dataset.productUrl, location.origin).pathname.replace(/\/$/, '');
      if (destination.origin !== location.origin || destination.hash !== '#fall-welcome' || destination.pathname.replace(/\/$/, '') !== productPath) return;
      if (openOffer(link)) event.preventDefault();
    });
    const purchaseObserver = new MutationObserver(() => { queueMotion(); if (!offerActive()) expireOffer(); });
    const purchaseCard = $('.ca-f-purchase-card');
    if (purchaseCard) purchaseObserver.observe(purchaseCard, { childList: true, subtree: true });

    let observer;
    if ('IntersectionObserver' in window && root.dataset.caMotionReady !== 'true') {
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.animate([{ opacity: .72, translate: '0 14px' }, { opacity: 1, translate: '0 0' }], { duration: 580, easing: 'cubic-bezier(.23,1,.32,1)' });
          observer.unobserve(entry.target);
        });
      }, { threshold: .14 });
      $$('[data-ca-f-reveal], .ca-f-visible-facts li, .ca-f-spec-list>div').forEach(element => observer.observe(element));
    }

    const destroy = () => {
      cancelImage();
      timeRevision += 1;
      timeRequest?.abort();
      clearTimeout(offerTimer);
      purchaseObserver.disconnect();
      if (offerDialog?.open && canOfferOverlay) {
        offerDialog.close();
        if (offerBackdrop) offerBackdrop.hidden = true;
        document.documentElement.style.overflow = offerOverflow;
      }
      if (viewer?.open) {
        viewer.close();
        document.documentElement.style.overflow = oldOverflow;
      }
      life.abort();
      observer?.disconnect();
      if (frame) cancelAnimationFrame(frame);
      instances.delete(root);
    };
    root.dataset.caFeaturedReady = 'true';
    if (canOfferOverlay) {
      const closeButton = $('[data-ca-offer-close]');
      if (closeButton) closeButton.hidden = false;
      const copyButton = $('[data-ca-offer-copy]');
      if (copyButton) copyButton.hidden = false;
    }
    const timeControls = $('[data-ca-time-controls]');
    if (timeControls) timeControls.hidden = false;
    expireOffer();
    if (offerHasResponse || location.hash === '#fall-welcome') openOffer();
    queueMotion();
    instances.set(root, { destroy });
  }

  function init(context = document) {
    if (context.matches?.('[data-ca-featured]')) mount(context);
    context.querySelectorAll('[data-ca-featured]').forEach(mount);
  }
  window.CedarAmberFeatured = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => instances.forEach((instance, root) => { if (event.target.contains(root)) instance.destroy(); }));
})();
